import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ActionButtons from './../../../../common/components/UI/ActionButtons/ActionButtons';

export default class FormDialog extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {

    const { open, title, contentText, content, submit, cancelDelete } = this.props;

    return (
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {contentText}
            </DialogContentText>
            {content}
          </DialogContent>
          <DialogActions>
              <ActionButtons
                  cancel={cancelDelete}
                  submit={submit}
              />
          </DialogActions>
        </Dialog>
    );
  }
}